import { createAsyncThunk } from '@reduxjs/toolkit';
import axios, { Method } from 'axios';

type OptionsType = {
  method: Method;
  url: string;
  contentType?: 'json' | 'form-data';
  params?: any;
  data?: any;
  token?: string;
  signal?: {};
  shouldAddSocketId?:boolean;
};

// Format Request Options
export function requestOptions(
  method: OptionsType['method'],
  url: OptionsType['url'],
  params: OptionsType['params'],
  contentType: OptionsType['contentType'],
  data: OptionsType['data'],
  token: OptionsType['token'],
  signal?: any,
  shouldAddSocketId?:boolean,
) {
  const socketId = sessionStorage?.getItem('socket_id');
  const options = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      ...(socketId && shouldAddSocketId ? { 'X-Socket-ID': socketId } : {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    method,
    url,
    params,
    data,
    signal,
  };
  if (method !== 'POST' && method !== 'PUT' && method !== 'PATCH' && params) {
    options.params = params;
  } else if (contentType === 'json') {
    options.headers['Content-Type'] = 'application/json';
    options.params = '';
    options.data = params;
  } else if (contentType === 'form-data') {
    options.headers['Content-Type'] = 'multipart/form-data';
    options.data = params;
    options.params = '';
  } else {
    options.data = params;
  }
  return options;
}

// Common Request

export const request = (
  options: OptionsType,
  name: string,
) => createAsyncThunk(name, async (payload: any, { rejectWithValue }) => {
  try {
    const res = await axios(
      requestOptions(
        options.method,
        options.url,
        payload,
        options.contentType,
        options.data,
        options.token,
        options.signal,
        options.shouldAddSocketId,
      ),
    );
    return res.data;
  } catch (error: any) {
    return rejectWithValue(error?.response?.data);
  }
});

export function getBaseUrl() {
  return import.meta.env.VITE_API_BASE_URL;
}

export function getPusherKey() {
  return import.meta.env.VITE_PUSHER_APP_KEY;
}
